module.exports = __webpack_public_path__ + "img/details-bg@3x.fdd45794.png";